export default {"src":"/_next/static/media/enerflo-instant-quoting-icon.928511a1.svg","height":79,"width":93};